import { useHasPermissions } from '../../../helpers/auth-helpers/auth.hooks';
import { Permissions } from '../../../helpers/auth-helpers/auth.type';
import { useGlobalStore } from '../../../store/global-store/global-store';

/**
 * Determines whether agent API cost figures should be displayed on the agent
 * miner surfaces (sessions table, session detail, and session panel).
 *
 * Cost is shown only when BOTH hold:
 * 1. The user has Financials read access (`useHasPermissions` fails open when
 *    RBAC is disabled for the org, preserving the default-show behavior).
 * 2. The organization has not opted to hide it via `hide_agent_miner_api_cost`,
 *    which overrides to hide even for users who have Financials read access.
 *
 * @returns {boolean} true when API cost should be displayed
 */
const useShowAgentMinerApiCost = (): boolean => {
  const hasFinancialsRead = useHasPermissions(Permissions.FinancialsRead);
  const hideApiCost = useGlobalStore((state) => state.organization?.hide_agent_miner_api_cost ?? false);

  return hasFinancialsRead && !hideApiCost;
};

export { useShowAgentMinerApiCost };
